const {FComponent} = require("../../../../common/react/f-component");

interface S {
    sizeIndex: number;
}

type R = {
    le: (sizeName: string) => boolean,
};

interface P {
    sizes: Map<String, number>;
    next: (r: R) => any;
}

export class Responsive extends FComponent<P, S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            sizeIndex: getSizeIndex(window.innerWidth, this.props.sizes),
        };

        let listener = () => {
            const sizeIndex = getSizeIndex(window.innerWidth, this.props.sizes);
            if (this.state.sizeIndex !== sizeIndex) {
                this.setState({sizeIndex});
            }
        };
        window.addEventListener("resize", listener);
        this.onUnmount(() => window.removeEventListener("resize", listener));
    }

    render() {
        const {next, sizes} = this.props;
        const {sizeIndex} = this.state;

        return next({
            lt: (sizeName) => sizeIndex < toNameIndex(sizeName, sizes),
            ge: (sizeName) => sizeIndex >= toNameIndex(sizeName, sizes),
        });
    }
}


const getSizeIndex = (w, sizes) => {
    const keys = Object.keys(sizes);
    for (let i = 0; i < keys.length; i++) {
        const sizeName = keys[i];
        if (w < sizes[sizeName]) {
            return i - 1;
        }
    }
    return keys.length - 1;
};
const toNameIndex = (index, sizes) => {
    return Object.keys(sizes).indexOf(index);
};